/**
 * Mastodon API client - Notifications endpoints
 */

import { get, post, buildQuery } from "./http";
import type { Notification, NotificationType, PaginationParams } from "./types";

export interface NotificationParams extends PaginationParams {
	/** Filter to specific notification types */
	types?: NotificationType[];
	/** Exclude specific notification types */
	exclude_types?: NotificationType[];
	/** Filter to notifications from specific account */
	account_id?: string;
}

/**
 * Get all notifications
 */
export async function getNotifications(params?: NotificationParams): Promise<Notification[]> {
	const query = params ? buildQuery(params) : "";
	return get<Notification[]>(`/api/v1/notifications${query}`);
}

/**
 * Get a single notification
 */
export async function getNotification(id: string): Promise<Notification> {
	return get<Notification>(`/api/v1/notifications/${id}`);
}

/**
 * Dismiss a single notification
 */
export async function dismissNotification(id: string): Promise<void> {
	return post(`/api/v1/notifications/${id}/dismiss`);
}

/**
 * Clear all notifications
 */
export async function clearNotifications(): Promise<void> {
	return post("/api/v1/notifications/clear");
}

/**
 * Get unread notification count (Mastodon 4.3+)
 */
export async function getUnreadCount(params?: {
	types?: NotificationType[];
	exclude_types?: NotificationType[];
	account_id?: string;
}): Promise<{ count: number }> {
	const query = params ? buildQuery(params) : "";
	return get(`/api/v1/notifications/unread_count${query}`);
}

export const notifications = {
	getAll: getNotifications,
	get: getNotification,
	dismiss: dismissNotification,
	clear: clearNotifications,
	getUnreadCount,
};
